import React from "react";
import { HiArrowNarrowRight } from 'react-icons/hi';
import { FaDotCircle } from 'react-icons/fa';

// prop -> routes : array of routes
const SwapRoutes = ({ routes }) => {
	// console.log("allroutes", routes);
	return (
		<div className="w-full h-fit flex flex-col">
            <h3 className={`text-lg font-bold ${routes.length < 1 ? 'text-gray-200/10' : 'text-gray-200/50'}`}>Routing {routes.length < 1 && 'not available'}</h3>

			<section className="mt-3 border-dashed border-l border-white/20">
				<div className="ml-3 my-1">
					{routes.length > 0 && <MainRoute routes={routes} />}
				</div>
			</section>
		</div>
	);
};

export default SwapRoutes;

const MainRoute = ({ routes }) => {
	return routes.map((routesArray, idx) => (
		<div key={idx} className="flex flex-col gap-10">
			<span className="w-fit flex flex-row gap-3 items-center">
				{/* {routesArray[0].name} */}
				{routesArray.map((route, idx) => (
                    <>
                        <div className="multi-route-path">
                            <span className="text-blue-600 animate-pulse"><FaDotCircle/></span>
							{routesArray.length > 1 && <i className="text-gray-500"> <HiArrowNarrowRight /> </i>}
                        </div>
						<div className="px-4 py-1 flex flex-col gap-1 items-end bg-black/20 text-gray-200/50 rounded-lg">
							<div key={idx} className="text-sm font-mono">
								{route.name}
							</div>
							<div className="text-xs">{route.part}%</div>
						</div>
					</>
				))}
            </span>
			<span></span>
		</div>
	));
};
